// Background polling for push notifications. Used by PushNotificationManager
// as a web fallback for environments without active service-worker push.
import { supabase } from "@/integrations/supabase/client";

let pollTimer: number | null = null;
let pollUserId: string | null = null;

async function checkOnce(userId: string): Promise<void> {
  try {
    await supabase.rpc("process_pending_push_notifications", { p_user_id: userId });
  } catch {
    /* silent */
  }
}

export function startBackgroundPolling(userId: string, intervalMs = 60_000): void {
  if (typeof window === "undefined" || !userId) return;
  stopBackgroundPolling();
  pollUserId = userId;
  checkOnce(userId);
  pollTimer = window.setInterval(() => checkOnce(userId), intervalMs);
}

export function stopBackgroundPolling(): void {
  if (pollTimer !== null) {
    clearInterval(pollTimer);
    pollTimer = null;
  }
  pollUserId = null;
}

export async function forceNotificationCheck(): Promise<void> {
  if (pollUserId) await checkOnce(pollUserId);
}
